// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "meal-3myKW";
var _4 = "meal_fullSize-2ijo9";
var _5 = "header-3XSZM";
var _6 = "image-3wbzr";
var _7 = "marker-1D6HS";
var _8 = "title-P_PXw";
var _9 = "name-3u13R";
var _a = "weight-32489";
var _b = "hasWeight-1OnsS";
var _c = "meal__item_selected-_Ro0-";
var _d = "meal__item_selected_borderFooter-1bEMo";
var _e = "meal__item_selected_borderTitle-3xBFy";
var _f = "footer-3zjPR";
var _10 = "footer__icons-1O7HX";
var _11 = "price-1HKWy";
var _12 = "oldPrice-1EVTx";
var _13 = "count-1oOTR";
var _14 = "popup__root-AKJDO";
var _15 = "popup-3puZL";
var _16 = "popup__close-H8hr7";
var _17 = "popup__scrollPaper-1GPx1";
export { _1 as "__esModule", _2 as "mobile", _3 as "meal", _4 as "meal_fullSize", _5 as "header", _6 as "image", _7 as "marker", _8 as "title", _9 as "name", _a as "weight", _b as "hasWeight", _c as "meal__item_selected", _d as "meal__item_selected_borderFooter", _e as "meal__item_selected_borderTitle", _f as "footer", _10 as "footer__icons", _11 as "price", _12 as "oldPrice", _13 as "count", _14 as "popup__root", _15 as "popup", _16 as "popup__close", _17 as "popup__scrollPaper" }
export default { "__esModule": _1, "mobile": _2, "meal": _3, "meal_fullSize": _4, "header": _5, "image": _6, "marker": _7, "title": _8, "name": _9, "weight": _a, "hasWeight": _b, "meal__item_selected": _c, "meal__item_selected_borderFooter": _d, "meal__item_selected_borderTitle": _e, "footer": _f, "footer__icons": _10, "price": _11, "oldPrice": _12, "count": _13, "popup__root": _14, "popup": _15, "popup__close": _16, "popup__scrollPaper": _17 }
